module.exports = __webpack_public_path__ + "img/6.4a4d641c.png";